export default theme => ({
  root: {
    padding: theme.spacing.unit * 2,
  },
  formButtons: {
    marginTop: theme.spacing.unit * 2,
    justifyContent: 'flex-end',
  },
  submit: {
    fontSize: '100%',
  },
  cancel: {
    fontSize: '100%',
  },
  button: {
    fontSize: '100%',
  },
});



// WEBPACK FOOTER //
// ./src/form-styles.js